

export enum ScheduleStatus {
    NOT_SCHEDULED   = 0,
    SCHEDULED       = 1,
    SOMEDAY         = 2
}


export type Priority = 1 | 2 |3 |4|5|6|7|8|9|10|50|100